<mat-card class="overflow-hidden h-100 leaderBoard">
    <mat-card-header [style.background-color]="community?.leaderboard_header_bg_color_hex"
                     class="align-items-center gap-10 noDarkMode">
        <mat-card-title>
            <div class="flex-row gap-10 align-items-center">
                <mat-icon
                        [style.color]="this.themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)">
                    timeline
                </mat-icon>
                <div [style.color]="this.themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)">

                    <div [innerHTML]="community?.points_leaderboard_tile_name_rendered || 'Points leaderboard'"
                         class="noMargin"></div>
                </div>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <div *ngIf="community" class="d-flex flex-col ml-auto mt-10 mb-10">
                <app-custom-toggle-group (buttonClick)="listenPointsUpdateEvents($event)" [community]="community"
                                         [compact]="true" [defaultValue]="mode" [options]="modeOptions"
                                         [styledDatePicker]="true"></app-custom-toggle-group>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <div *ngIf="isDialog" class="float-end">
        <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                tabindex="-1">
            <mat-icon [style.color]="this.themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)"
                      class="accent-text">
                close
            </mat-icon>
        </button>
    </div>
    <div *ngIf="loading" class="flex-row justify-content-center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <ng-container *ngIf="!loading && loading != null">
        <mat-card-content *ngIf="users.length; else noUsers"
                          class="w-100 d-flex flex-col gap-15 pt-10 h-100 scrollControl leaderboardScroll">
            <div *ngFor="let user of users; trackBy: userTrack"
                 class="flex-row align-items-center gap-10">
                <div>
                    <div [matMenuTriggerFor]="menu" class="miniInitial bg-primary mb-0 clickable"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                         mat-card-avatar>
                        <div [appUserAvatar]="user" class="userPicture"></div>
                    </div>
                    <mat-menu #menu="matMenu" class="userDisplayMenu">
                        <ng-container *ngIf="userInfoMenuOpen">
                            <app-user-info [user]="user"></app-user-info>
                        </ng-container>
                    </mat-menu>
                </div>
                <div class="flex-col">
                    <p class="m-0 breakWord">{{ user.username }}</p>
                    <small class="muted"><span [countUp]="user.points" [duration]="500">{{ user.points }}</span> Points</small>
                </div>
            </div>
        </mat-card-content>
    </ng-container>
</mat-card>

<ng-template #noUsers>
    <div class="muted p-10">There are no users in this community yet with a large number of points for this period</div>
</ng-template>
